import { Fragment } from 'react';
import { useSearchParams } from 'react-router-dom';
import Filter, { setl10nKeyToTitle } from '@components/contents/common/Filter';
import { selectL10N } from '@features/ui/UiSlice';
import { useAppSelector } from '@hooks/defineRtkTypedHook';
import type { IFilterL10nItem } from '@type/ui';

interface IFilterWrapProps {
  filterDataObj: { [key: string]: IFilterL10nItem[] } | null;
  option?: { [key: string]: any };
  changeCallback?: () => void;
}

const FilterWrap = ({ filterDataObj, option, changeCallback }: IFilterWrapProps) => {
  if (!filterDataObj) {
    return <Fragment />;
  }

  const l10n = useAppSelector(selectL10N);
  const filterData = Object.entries(filterDataObj);
  // Filter 내부에서 선언 시, ncuiDropdown에 전달하는 searchParams 값이 각 필터간 동기화되지 않아 필터 외부에서 선언해서 props로 주입함
  const [searchParams, setSearchParams] = useSearchParams();

  return Array.isArray(filterData) && filterData?.length > 0 ? (
    filterData.map((data) => {
      const key = data[0];
      const value = data[1];
      const hasAllBlankValue = value?.filter((v) => !v?.value)?.length > 0;

      return (
        <Filter
          key={key}
          filterData={setl10nKeyToTitle(value, l10n!)}
          searchParams={searchParams}
          setSearchParams={setSearchParams}
          changeCallback={changeCallback}
          option={{
            ...option,
            name: key,
            useAllBlankValue: hasAllBlankValue,
          }}
        />
      );
    })
  ) : (
    <Fragment />
  );
};

export default FilterWrap;
